import UArray from "./UArray.mts";
import UFunction from "./UFunction.mts";
import UObject from "./UObject.mts";

namespace USearchParams {
  export type Object = Record<string, string[]>;

  export namespace Object {
    export const normalize = (obj: Denormalized): Object =>
      UObject.transform(
        obj,
        ([key, value]) => [key, UArray.ensure(value)] as const,
      );

    export type Denormalized = Record<string, string | string[]>;

    export const denormalize = (obj: Object): Denormalized =>
      UObject.transform(
        obj,
        ([key, value]) =>
          [key, UArray.withLengthOf(value, 1)?.[0] ?? value] as const,
      );
  }

  export const toObject = (searchParams: URLSearchParams) =>
    UObject.groupByEntry(searchParams.entries(), UFunction.identity);
}

export default USearchParams;
